import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import {
  useGetLocationsQuery,
  useGetWeatherAlertsRulesQuery,
} from "../store/slices/mapsSlice";
import MyPagination from "../Common/MyPagination";
import ContactCard from "../Contacts/ContactCard";
import { Link } from "react-router-dom";
import {
  WeatherAlertConditions,
  WeatherAlertOperators,
} from "../WeatherAlerts/WeatherAlertConstants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo } from "@fortawesome/free-solid-svg-icons";
import { OverlayTrigger } from "react-bootstrap";

export default function WeatherAlertsSidebar({
  bounds,
  filters,
}: {
  bounds: any;
  filters: any;
}) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [pagination, setPagination] = useState({
    page: 0,
    perPage: 10,
    search: "new",
  });

  const { data: { alerts = [], total } = { items: [], total: 0 } } =
    useGetWeatherAlertsRulesQuery(
      {
        ...filters,
        Coordinates: [[bounds]],
        Limit: pagination.perPage,
        Offset: pagination.page * pagination.perPage,
        WithContacts: true,
        Zoom: 30,
      },
      { skip: !show }
    );

  return (
    <>
      <Button
        variant="link"
        onClick={handleShow}
        className="p-0 mx-2 align-baseline"
      >
        See the rules.
      </Button>

      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        style={{ width: "50%" }}
      >
        <Offcanvas.Header closeButton className="bg-colored-reverse text-white">
          <Offcanvas.Title className="fw-bold"> Map Items</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="bg-page">
          <table className="table">
            <thead>
              <tr>
                <th>Active</th>
                <th>Stop</th>
                <th>Description</th>
                <th>Priority</th>
                <th>ShapeId</th>
                <th>Conditions</th>
              </tr>
            </thead>
            <tbody>
              {alerts.map((a) => (
                <tr key={a.ID}>
                  <td>
                    {a.Active ? (
                      <span className="badge bg-success">YES</span>
                    ) : (
                      <span className="badge bg-secondary">NO</span>
                    )}
                  </td>
                  <td>
                    {a.Stop ? (
                      <span className="badge bg-success">YES</span>
                    ) : (
                      <span className="badge bg-secondary">NO</span>
                    )}
                  </td>
                  <td>
                    <Link to={`/library/weather-alerts/${a.ID}`}>
                      {a.Description}
                    </Link>
                  </td>
                  <td>{a.Priority}</td>
                  <td>{a.ShapeId}</td>
                  <td>
                    {a.Conditions.map((c) => (
                      <div>
                        <span
                          title={`${
                            WeatherAlertConditions.find(
                              (wac) => wac.key === c.Condition
                            )?.label
                          } ${
                            WeatherAlertOperators.find(
                              (wao) => wao.symbol === c.ConditionOperator
                            )?.desc
                          } ${c.ConditionValue} ${
                            WeatherAlertConditions.find(
                              (wac) => wac.key === c.Condition
                            )?.unit
                          }`}
                        >
                          {c.Description}
                        </span>
                      </div>
                    ))}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <MyPagination
            onPaginate={(page: any, perPage: any) =>
              setPagination((p) => ({
                ...p,
                page: parseInt(page),
                perPage: parseInt(perPage),
              }))
            }
            total={total}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
